var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.34315L9.73726 8.60589L10.8686 9.73726L13.1314 7.47452C14.0648 6.54114 15.5921 6.54114 16.5255 7.47452C17.4589 8.4079 17.4589 9.93525 16.5255 10.8686L14.2627 13.1314L15.3941 14.2627L17.6569 12C19.2181 10.4387 19.2181 7.90444 17.6569 6.34315C16.0956 4.78186 13.5613 4.78186 12 6.34315ZM13.1314 14.2627L10.8686 16.5255C9.93525 17.4589 8.4079 17.4589 7.47452 16.5255C6.54114 15.5921 6.54114 14.0648 7.47452 13.1314L9.73726 10.8686L8.60589 9.73726L6.34315 12C4.78185 13.5613 4.78185 16.0956 6.34315 17.6569C7.90444 19.2181 10.4387 19.2181 12 17.6569L14.2627 15.3941L13.1314 14.2627ZM9.17157 13.6971L13.6971 9.17158L14.8284 10.3029L10.3029 14.8284L9.17157 13.6971Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.6d420a80c3a93a124a4b35c0321b3bb4.svg";
export { ForwardRef as ReactComponent };